export default {
    ExpenseOther: 5
}